module.exports = __webpack_public_path__ + "img/whatsapp.13689b97.svg";